module.exports = __webpack_public_path__ + "static/logo_dark-3eeeec0c4c3cdfd3f05d246ec2864899.png";